import src from "IMAGE";
export default { src, width: 640, height: 640, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRm8AAABXRUJQVlA4TGMAAAAvB8ABAM1VICICHghADgIAAID/9tss2terAAAAAgCAAAAAAAAAAAAAAAAAAAAAAIAAAABECACk7Q8AABAROVJzDKAOLxM7/QjHuQi8s5hGBG7v/RXlVBW27lHrc+VNOZUssy0A"};
